
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MainSubtitle from '../../components/shared/typography/MainSubtitle';
import Paragraph from '../../components/shared/typography/Paragraph';
import MainBoxSx from '../../components/shared/boxes/MainBox';
import SsoModal from './SsoModal';
import { toCamelCase } from '../helpers/helpers';
import SettingsSwitch from './SettingsSwitch';

const AuthContainer = () => {
    const [idpConfig, setIdpConfig] = useState({});
    const [configApiError, setConfigApiError] = useState(null);


    const updateIdpConfig = (response) => {
        if (response === null) {
            return;
        }

        const updatedIdpConfig = { ...idpConfig };
        Object.keys(response).forEach((key) => {
            const camelCasedKey = toCamelCase(key);
            updatedIdpConfig[camelCasedKey] = response[key];
        });

        setIdpConfig(updatedIdpConfig);
    };

    useEffect(() => {
        const fetchIdpConfig = async () => {
            const response = await fetch('/account_idp_configs', {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new TypeError("Oops, we haven't got JSON!");
            }

            const responseJson = await response.json();

            if (!response.ok) {
                const errorMessage = `Error ${response.status}: ${responseJson?.error || 'Unknown error'}`;
                return setConfigApiError({ errorMessage });
            }

            updateIdpConfig(responseJson);

        };

        fetchIdpConfig();
    }, []);

    return (
        <Box sx={{ ...MainBoxSx, padding: '2rem' }}>
            <MainSubtitle>SSO (Single Sign-On)</MainSubtitle>
            <Paragraph>
                Para permitir que a sua equipe acesse o sistema com mais segurança e sem precisar de várias senhas é possível
                integrar o Produttivo com o seu provedor de identidade através da autenticação Single Sign-On (SSO).
            </Paragraph>
            <SettingsSwitch config={idpConfig} />
            {configApiError && (
                <ErrorBox errorMessage={configApiError.errorMessage} onClose={() => setConfigApiError()} />
            )}
            <SsoModal idpConfig={idpConfig} updateIdpConfigCallback={updateIdpConfig} />
        </Box>
    );
};

export default AuthContainer;